import { CustomModal } from "@pw/batch-widgets";
import { FC, Fragment, useMemo } from "react";
import style from "./style.module.css";
import { BatchPlan, BatchPlus } from "../batch.type";
import useComparePlans from "@api/hooks/ambassador-batch/useGetComparePlans";
import useUpgradeBannerSnooze from "@api/hooks/ambassador-batch/useUpgradeBannerSnooze";
import { getPlusDefaultPlan } from "@utils/utilities";
import { POP_UP_CTA_NAME } from "@utils/constants";
import ComparisonTable from "../ComparisonTable";
import { Dialog, Transition } from "@headlessui/react";

interface props {
  onClose: (clickedFrom?: string, plan?: any) => void;
  open: boolean;
  eventDetails: eventProps;
  config?: BatchPlus;
}

interface eventProps {
  popupCtaName: string;
  pageName: string;
  batchName: string;
  batchId: string;
  selectedPlanId?: string;
  selectHighestPlan?: boolean;
}

const BatchPlusComparisonModal: FC<props> = ({
  onClose,
  open,
  config,
  eventDetails,
}) => {

  const { pageName, popupCtaName, batchName, batchId, selectHighestPlan } =
    eventDetails;

  const { data: plansConfig, isLoading: plansLoading } = useComparePlans({
    batchId: batchId,
    enable: !!batchId && !config,
  });
  const { mutate: upgradeBannerSnooze } = useUpgradeBannerSnooze();

  const plansData = plansConfig || config;

  const defaultPlan = useMemo(() => {
    return getPlusDefaultPlan(plansData);
  }, [plansData]);

  const currentPlan = useMemo(
    () => plansData?.plans?.find((plan: BatchPlan) => plan?.isPlanPurchased),
    [plansData],
  );


  const handleTableClose = (clickedFrom?: string, plan?: any) => {
    if (clickedFrom === "close_icon" && popupCtaName === "explore") {
    }

    if (
      clickedFrom === "close_icon" &&
      popupCtaName === POP_UP_CTA_NAME.ALL_CLASSES_UPGRADE_BANNER
    ) {
      upgradeBannerSnooze({ batchId, snoozed: true });
    }

    if (
      clickedFrom === "close_icon" &&
      popupCtaName === POP_UP_CTA_NAME.BUY_NOW
    ) {
      const payload = {
        planId: defaultPlan?._id,
        batchSlug: batchId,
        cameFrom: "batch_listing",
        pageName: pageName,
      };


    }

    onClose(clickedFrom, plan);
  };

  return (
    <Transition appear show={open} as={Fragment}>
      <Dialog as="div" className="relative z-[1000]" onClose={() => { }}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black bg-opacity-50" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel className="w-full max-w-[720px] h-[610px] transform overflow-hidden rounded-md bg-[#101014] text-left align-middle shadow-xl transition-all outline-none mt-16">
                {plansLoading ? (
                  <section className={style.loading_section}>
                    <div className={style.loader} />
                  </section>
                ) : (
                  <ComparisonTable
                    config={config || plansConfig}
                    pageName={pageName}
                    ctaName={popupCtaName}
                    batchName={batchName}
                    onClose={handleTableClose}
                    slug={batchId}
                    selectedPlanId={eventDetails?.selectedPlanId}
                    selectHighestPlan={selectHighestPlan}
                  />
                )}
              </Dialog.Panel >
            </Transition.Child >
          </div >
        </div >
      </Dialog >
    </Transition >
  );
};

export default BatchPlusComparisonModal;
